import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid2 as Grid,
  Typography,
} from "@mui/material";
import parse from "html-react-parser";
import { QuestionnaireType } from "../../../../utils/Types/QuestionnaireType";
import { QuestionnaireProgressType } from "../../../../utils/Types/QuestionnaireProgressType";
import QuestionnaireState from "../QuestionnaireState";

interface IntroductionType {
  questionnaire: QuestionnaireType;
  questionnaireProgress: QuestionnaireProgressType;
}

const Introduction = ({
  questionnaire,
  questionnaireProgress,
}: IntroductionType) => {
  return (
    <Grid container>
      <Grid size={{ xs: 12 }}>
        <Card>
          <CardContent>
            <Typography variant="h2" mb={2}>
              Dotazník {questionnaire.jobTitle}
            </Typography>
            <QuestionnaireState
              questionnaireProgress={questionnaireProgress}
              questionnaireId={parseInt(questionnaire.id)}
            />
            <Box mx={2}>
              {questionnaire.customText && parse(questionnaire.customText)}
              {questionnaire.customText2 && parse(questionnaire.customText2)}
              <Divider />
              {questionnaire.customText3 && parse(questionnaire.customText3)}
            </Box>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default Introduction;
